import "../../styles/common.css";
import closeIcon from "../../assets/images/close-icon.svg";
import infoIcon from "../../assets/images/info-blue.svg";
import verifiedLogo from "../../assets/images/icon128.png";
import walletConnectIcon from "../../assets/images/wallet-connect-icon.webp";
import { useAppKit } from "@reown/appkit/react";
import { networks } from "../../utils/constants";
import { fetchSumsubAccessToken, useGlobal } from "../../context/globalContext";

const Login = (props) => {
  const appKitModal = useAppKit();

  const { login } = useGlobal();

  return (
    <div className="switch-network-popup">
      <div className="switch-network-popup-first">
        <div
          style={{ gap: "20px", marginTop: "10px", marginBottom: "10px" }}
          className="switch-network-popup-first-section-body"
        >
          <div
            onClick={async () => {
              try {
                if (window?.verifiedwallet?.request) {
                  props.setCustomLoading(true);
                  await window.verifiedwallet
                    .request({
                      method: "connectWallet",
                    })
                    .then(async (res) => {
                      if (res?.length > 0) {
                        props.setVerifiedWalletDetails(res[0]);

                        localStorage.setItem("myVault", JSON.stringify(res[0]));

                        props.setShowPopup(false);
                        await login(res[0]);

                        props.setCustomLoading(false);
                      }
                    });
                } else {
                  alert(
                    "Verified Wallet not installed. Install Verified Wallet from Webstore and try again.",
                  );
                }
              } catch (err) {
                props.setCustomLoading(false);
              }
            }}
            className="switch-network-popup-first-section-content-cont"
          >
            <div className="switch-network-popup-first-section-content">
              <img
                style={{
                  height: "32px",
                  width: "32px",
                  overflow: "hidden",
                  borderRadius: "40px",
                }}
                src={verifiedLogo}
                alt="Chain Icon"
              />

              <p className="switch-network-popup-first-section-cont-text">
                Verified Wallet
              </p>
            </div>
          </div>

          <div
            onClick={async () => {
              await appKitModal.open().then(() => {
                props.setShowPopup(false);
              });
            }}
            className="switch-network-popup-first-section-content-cont"
          >
            <div className="switch-network-popup-first-section-content">
              <img
                style={{
                  height: "32px",
                  width: "32px",
                  overflow: "hidden",
                  borderRadius: "40px",
                }}
                src={walletConnectIcon}
                alt="Chain Icon"
              />
              <p className="switch-network-popup-first-section-cont-text">
                Other Wallets
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="switch-network-popup-line"></div>

      <div className="switch-network-popup-second">
        {/* <p className="switch-network-popup-second-title">
          It is reconmmended to login using Verified Wallet as it is faster and
          offer gassless transactions, paid for using our Cash Tokens.
        </p> */}
        <div className="switch-network-popup-second-text-cont">
          <img src={infoIcon} alt="Info Icon" />
          <a
            style={{
              color: "var(--secondary-electric-violet-700, #4e2bd7)",

              fontFamily: "Roboto",
              fontSize: "0.75rem",
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "140%",
            }}
            className="switch-network-popup-second-text"
            href="https://chromewebstore.google.com/detail/verified-wallet/abkgckcpmnbipkfhkkchkdfkmccjdmkh"
            target="_blank"
            rel="noopener noreferrer"
          >
            What is Verified Wallet
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
